import {uniqueId} from 'lodash'

const writeOffsTable = {
  columns: {
    getColumnsData: 'writeOffColumnsData',
    setColumnsData: 'setWriteOffColumnsData'
  },
  rows: {
    getRowsData: 'writeOffRowsData',
    setRowsData: 'setWriteOffRowsData'
  }
}

const columns = [
  {
    title: 'Date',
    type: 'date',
    property: 'writeOffDate'
  },
  {
    title: 'Proforma No.',
    property: 'writeOffInvoice.number',
    hover: true
  },
  {
    title: 'Amount',
    isNumber: true,
    statusNumber: true,
    property: 'writeOffValue',
    statusRevert: true
  }
]

const prefix = 'write_offs_column_'
const writeOffsTableColumns = columns.map(col => {
  col.id = uniqueId(prefix)
  col.typeTable = 'writeOffs'
  return col
})

export {writeOffsTable, writeOffsTableColumns}



// WEBPACK FOOTER //
// ./src/constants/TablesOptions/writeOffsTable.js